var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForBusiness(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 302,
    viewBox: "0 0 411 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M81.0018 293.156C79.6482 305.459 8.5858 304.426 8.69348 293.155C10.0471 280.853 81.1094 281.886 81.0018 293.156Z",
    fill: "#2F2E41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.591 261.585L51.4715 267.823L56.7529 267.343L60.1133 256.307L54.8324 253.428L48.591 261.585Z",
    fill: "#FFB8B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4597 275.952L30.346 280.299L38.5078 280.779V275.501L30.4597 275.952Z",
    fill: "#FFB8B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2284 196.807L35.1489 235.194L30.3475 276.94L44.7512 278.86L53.873 226.078L56.7539 190.089L33.2284 196.807Z",
    fill: "#2F2E41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6632 182.892C10.6632 182.892 4.90192 220.799 16.9047 233.275C28.9075 245.751 45.2312 267.823 45.2312 267.823L56.7539 253.428L27.4671 222.239L33.2285 201.126L56.7539 190.09L52.913 163.698L18.345 163.219L10.6632 182.892Z",
    fill: "#2F2E41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9883 95.0816C33.1548 95.0816 28.4259 90.3553 28.4259 84.5252C28.4259 78.695 33.1548 73.9688 38.9883 73.9688C44.8218 73.9688 49.5508 78.695 49.5508 84.5252C49.5508 90.3553 44.8218 95.0816 38.9883 95.0816Z",
    fill: "#FFB8B8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8671 86.9244C29.8671 86.9244 29.3869 101.799 26.9864 103.719C24.5858 105.638 35.6284 113.795 35.6284 113.795L42.8301 102.279V91.7228L29.8671 86.9244Z",
    fill: "#FFB8B8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6676 107.078L28.8387 98.2809L25.5458 102.759L20.7444 116.195L24.5853 168.497L47.1508 168.977L50.0312 108.997L42.8299 100.36L34.6676 107.078Z",
    fill: "#D0CDE1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1531 110.436L62.994 109.957C62.994 109.957 63.9542 110.436 64.4343 113.795C64.9144 117.154 70.6758 146.904 70.6758 146.904L62.994 183.372L54.352 171.856L59.6332 151.702L54.352 131.549L59.1531 110.436Z",
    fill: "#2F2E41"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1839 109.957H7.30348L0.101662 148.823L6.82301 179.053L13.5448 168.017L11.6244 156.021L12.5844 145.465L15.9453 139.227L10.1839 109.957Z",
    fill: "#2F2E41"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9118 265.904C52.9118 265.904 50.0311 264.944 50.0311 266.864C50.0311 268.783 51.9516 274.541 51.9516 274.541C51.9516 274.541 49.0709 292.295 53.3919 291.335C57.7129 290.376 61.0737 282.218 61.5538 279.819C62.0339 277.42 64.4344 264.944 64.4344 264.944C64.4344 264.944 68.2753 255.827 65.8748 255.347C63.4742 254.868 56.7527 252.948 56.7527 252.948C56.7527 252.948 60.5936 264.944 52.9118 265.904Z",
    fill: "#2F2E41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9907 280.779C38.9907 280.779 31.3089 275.98 29.8686 279.819C28.9133 282.619 28.2693 285.516 27.9481 288.456C27.9481 288.456 26.0277 294.694 33.7094 293.734C41.3912 292.775 40.431 292.775 40.9111 289.896C41.3912 287.017 38.9907 280.779 38.9907 280.779Z",
    fill: "#2F2E41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7463 84.5252L34.6668 84.0454C34.6668 84.0454 36.1071 75.8882 39.4679 76.8478C42.8287 77.8075 51.4707 78.7672 51.4707 74.9285C51.4707 71.0898 43.3088 67.7309 38.5077 68.2108C33.7066 68.6906 25.5447 70.1301 26.0248 77.3277C26.5049 84.5252 29.6029 91.5269 29.6029 91.5269L29.8532 87.2595L32.7463 84.5252Z",
    fill: "#2F2E41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8307 112.836L34.6684 107.078L42.8307 100.36L45.6641 103.758L42.8307 112.836Z",
    fill: "#D0CDE1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4666 112.356L34.668 107.078L28.9071 98.4407L25.5461 102.759L27.4666 112.356Z",
    fill: "#D0CDE1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5156 109.957L47.152 103.719L43.5512 101.08L32.7487 148.823L25.547 127.231L27.7075 99.6401L7.78291 109.957L14.5045 142.586L15.4647 155.061L12.584 165.138C12.584 165.138 2.50168 172.336 5.86246 180.013C9.22324 187.69 13.0641 188.17 13.0641 188.17C13.0641 188.17 29.3879 172.815 30.3481 168.977C31.3084 165.138 32.7487 158.42 32.7487 158.42C32.7487 158.42 40.9106 189.13 50.5128 188.65C60.115 188.17 60.115 178.094 60.115 178.094L57.7145 167.537L53.8736 156.501L55.794 138.267L62.5156 109.957Z",
    fill: "#2F2E41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M410.47 0.190277H75.7695V214.425H410.47V0.190277Z",
    fill: "#2F2E41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M400.899 27.0601H85.3398V108.728H400.899V27.0601Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M230.565 38.8565H163.831V42.6851H230.565V38.8565Z",
    fill: "#E6E6E6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M266.882 52.8222H163.831V56.6508H266.882V52.8222Z",
    fill: "#E11736"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M247.816 65.9798H163.831V69.8083H247.816V65.9798Z",
    fill: "#E6E6E6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M212.86 79.0877H163.831V82.9163H212.86V79.0877Z",
    fill: "#E6E6E6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 92.1956H163.831V96.0242H237.828V92.1956Z",
    fill: "#E6E6E6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M141.588 37.4954H133.416V45.6622H141.588V37.4954Z",
    fill: "#E6E6E6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M141.588 50.653H133.416V58.8198H141.588V50.653Z",
    fill: "#E11736"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M141.588 63.8107H133.416V71.9775H141.588V63.8107Z",
    fill: "#E6E6E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M141.588 76.9683H133.416V85.1351H141.588V76.9683Z",
    fill: "#E6E6E6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M141.588 90.126H133.416V98.2929H141.588V90.126Z",
    fill: "#E6E6E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M356.77 56.0976H329.531V83.3203H356.77V56.0976Z",
    fill: "#E6E6E6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M400.899 120.071H85.3398V201.739H400.899V120.071Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M155.661 127.329H147.489V135.496H155.661V127.329Z",
    fill: "#E6E6E6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M141.588 127.329H133.416V135.496H141.588V127.329Z",
    fill: "#E11736"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M271.963 145.188C269.473 140.974 266.017 137.411 261.88 134.792C257.743 132.173 253.043 130.572 248.167 130.122C243.291 129.672 238.377 130.385 233.83 132.202C229.283 134.02 225.233 136.89 222.012 140.577L220.021 138.838C223.516 134.835 227.912 131.719 232.848 129.745C237.783 127.772 243.117 126.998 248.41 127.486C253.703 127.975 258.805 129.713 263.295 132.556C267.785 135.399 271.536 139.267 274.239 143.842L271.963 145.188Z",
    fill: "#E6E6E6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M273.211 179.619L271.017 178.145C274.267 173.299 276.081 167.634 276.249 161.803C276.417 155.972 274.932 150.212 271.965 145.189L274.241 143.842C277.462 149.296 279.074 155.549 278.892 161.879C278.71 168.21 276.741 174.36 273.211 179.619V179.619Z",
    fill: "#E11736"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M220.297 183.301C214.83 177.2 211.785 169.311 211.734 161.122C211.683 152.932 214.631 145.006 220.021 138.838L222.012 140.577C217.047 146.259 214.332 153.561 214.379 161.105C214.425 168.65 217.231 175.917 222.266 181.538L220.297 183.301Z",
    fill: "#E11736"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M245.319 194.481C240.597 194.477 235.928 193.48 231.617 191.554C227.306 189.628 223.449 186.816 220.297 183.301L222.267 181.538C225.411 185.049 229.316 187.795 233.685 189.567C238.053 191.339 242.769 192.091 247.472 191.763C252.175 191.436 256.741 190.039 260.822 187.678C264.902 185.318 268.389 182.057 271.016 178.144L273.21 179.619C270.14 184.195 265.989 187.945 261.125 190.537C256.26 193.129 250.832 194.483 245.319 194.481Z",
    fill: "#E11736"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M356.77 145.025H329.531V172.248H356.77V145.025Z",
    fill: "#E6E6E6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M159.519 162.72H132.28V189.943H159.519V162.72Z",
    fill: "#E6E6E6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M410.327 0H75.626V14.2112H410.327V0Z",
    fill: "#E11736"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1931 9.89947C87.6486 9.89947 88.8285 8.72021 88.8285 7.26553C88.8285 5.81085 87.6486 4.63159 86.1931 4.63159C84.7375 4.63159 83.5576 5.81085 83.5576 7.26553C83.5576 8.72021 84.7375 9.89947 86.1931 9.89947Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M96.196 9.89947C97.6515 9.89947 98.8314 8.72021 98.8314 7.26553C98.8314 5.81085 97.6515 4.63159 96.196 4.63159C94.7405 4.63159 93.5605 5.81085 93.5605 7.26553C93.5605 8.72021 94.7405 9.89947 96.196 9.89947Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M106.2 9.89947C107.655 9.89947 108.835 8.72021 108.835 7.26553C108.835 5.81085 107.655 4.63159 106.2 4.63159C104.744 4.63159 103.564 5.81085 103.564 7.26553C103.564 8.72021 104.744 9.89947 106.2 9.89947Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForBusiness);
export default __webpack_public_path__ + "static/media/ForBusiness.a149b892b7f1e4726e0edf48f91612ba.svg";
export { ForwardRef as ReactComponent };